import { render, staticRenderFns } from "./distributed_response.vue?vue&type=template&id=350e20b9&scoped=true&"
import script from "./distributed_response.vue?vue&type=script&lang=js&"
export * from "./distributed_response.vue?vue&type=script&lang=js&"
import style0 from "./distributed_response.vue?vue&type=style&index=0&id=350e20b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350e20b9",
  null
  
)

export default component.exports